import {
    IconCheck,
    IconGauge,
    IconUser,
    IconCookie,
    IconBook,
    IconPencilCheck,
    IconCertificate,
    IconChartHistogram,
    IconCopyCheck,
    IconDirections,
    IconSchool,
    IconTextGrammar,
    IconAlphabetGreek,
    IconBeach,
    IconMathSymbols,
    IconListSearch,
    IconAbc,
    IconDeviceTv,
    IconLifebuoy,
    IconMessageCircleUser,
    IconZoomCheck,
    IconLadder,
    IconRuler2,
    IconMessage2Heart,
    IconDeviceMobile,
    IconDevicesCheck,
} from '@tabler/icons-react';

const ICONS_MAP = {
    IconCheck,
    IconGauge,
    IconUser,
    IconCookie,
    IconBook,
    IconPencilCheck,
    IconCertificate,
    IconChartHistogram,
    IconCopyCheck,
    IconDirections,
    IconSchool,
    IconTextGrammar,
    IconAlphabetGreek,
    IconBeach,
    IconMathSymbols,
    IconListSearch,
    IconAbc,
    IconDeviceTv,
    IconLifebuoy,
    IconMessageCircleUser,
    IconZoomCheck,
    IconLadder,
    IconRuler2,
    IconMessage2Heart,
    IconDeviceMobile,
    IconDevicesCheck,
};

export default ICONS_MAP;
